import { buildBonusKitIconCandidates } from "./iconAssets";

/** @typedef {{ label: string, qty?: number, src: string, iconCandidates?: string[] }} BonusKitCell — label = nome PT (traduzir com `item()`) */

function catalogIcon(folder, file, label, qty) {
    const candidates = buildBonusKitIconCandidates(folder, file);
    const cell = {
        label,
        src: candidates[0] || "",
        iconCandidates: candidates.slice(1),
    };
    if (qty != null && qty !== 1) cell.qty = qty;
    return cell;
}

const MAIN_SLOTS = 24;

function mainGrid(entries) {
    const grid = Array(MAIN_SLOTS).fill(null);
    for (const { at, ...cell } of entries) {
        if (at >= 0 && at < MAIN_SLOTS) grid[at] = cell;
    }
    return grid;
}

/** Inventário do Kit Bónus (layout estilo Rust — Kit Items). Títulos `{ pt, en }`. */
export const VIP_BONUS_KIT = {
    title: { pt: "Kit Bónus", en: "Bonus Kit" },
    sections: [
        {
            key: "main",
            title: { pt: "Itens principais", en: "Main items" },
            cols: 6,
            cells: mainGrid([
                { at: 0, ...catalogIcon("Munição", "Bala de Pistola.webp", "Bala de pistola", 150) },
            ]),
        },
        {
            key: "wear",
            title: { pt: "Roupa (Wear)", en: "Wear" },
            cols: 7,
            cells: [
                catalogIcon("Roupas", "Capacete de Lata de Café.webp", "Capacete de Lata de Café"),
                catalogIcon("Roupas", "Blusão.webp", "Blusão"),
                catalogIcon("Roupas", "Botas.webp", "Botas"),
                catalogIcon("Roupas", "Calça.webp", "Calça"),
                catalogIcon("Roupas", "Luvas Táticas.png", "Luvas Táticas"),
                catalogIcon("Roupas", "Saia de Placas de Trânsito.webp", "Saia de Placas de Trânsito"),
                catalogIcon("Roupas", "Jaqueta de Placas de Trânsito.webp", "Jaqueta de Placas de Trânsito"),
            ],
        },
        {
            key: "belt",
            title: { pt: "Cinto (Belt)", en: "Belt" },
            cols: 6,
            cells: [
                catalogIcon("Armas", "MP5A4.webp", "MP5A4"),
                catalogIcon("Construção", "Muro Alto de Madeira.webp", "Muro alto de madeira", 2),
                catalogIcon("Medicamentos", "Seringa Médica.webp", "Seringa médica", 9),
                catalogIcon("Medicamentos", "Kit Médico Grande.webp", "Kit médico grande", 10),
                catalogIcon("Medicamentos", "Bandagem.webp", "Bandagem", 20),
                catalogIcon("Comida", "Abóbora.webp", "Mirtilos", 96),
            ],
        },
    ],
};
